import { render, staticRenderFns } from "./ColorComponent.vue?vue&type=template&id=829a9e88&"
import script from "./ColorComponent.vue?vue&type=script&lang=js&"
export * from "./ColorComponent.vue?vue&type=script&lang=js&"
import style0 from "./ColorComponent.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports